export default __webpack_public_path__ + "static/media/facebook.c79c752e.svg";